import { Offer } from "@/models/offer";
import { Pagination } from "@/models/pagination";
import { IOffer, OfferState } from "@/types/offer";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<OfferState, IOffer> = {
  single: (state, single) => {
    state.single = new Offer(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new Offer(item));
    state.pagination = new Pagination(pagination);
  },
  clear: (state) => {
    state.single = new Offer();
    state.pagination = new Pagination();
  },
};

export default mutations;
